import { EWalletId, getWalletName } from '@ankr.com/provider';
import { Box, Button, ButtonProps, Link, Typography } from '@mui/material';

import { getWalletIcon } from 'modules/common';
import { useTranslation } from 'modules/i18n';

import translation from './walletButton.translation';

interface Props extends ButtonProps {
  walletId: EWalletId;
  link?: string;
  installLink?: string;
}

export function WalletButton({
  link,
  installLink,
  walletId,
  ...props
}: Props): JSX.Element {
  const { t, keys } = useTranslation(translation);
  const linkProps = {
    href: link,
    rel: 'noreferrer',
    target: '_blank',
    component: 'a',
  };

  return (
    <Button
      data-tid={`auth-wallet-modal-button-${walletId}`}
      variant="outlined"
      size="extraLarge"
      type="button"
      sx={{ display: 'flex', justifyContent: 'flex-start' }}
      {...props}
      {...(link ? linkProps : {})}
    >
      <Box
        component="img"
        width={32}
        src={getWalletIcon(walletId) ?? ''}
        alt=""
      />

      <Typography variant="body2" fontWeight={700} ml={2}>
        {getWalletName(walletId)}
      </Typography>

      {installLink && (
        <Link
          variant="body2"
          sx={{ ml: 'auto', textDecoration: 'none' }}
          target="_blank"
          rel="noreferrer"
          href={installLink}
        >
          {t(keys.install)}
        </Link>
      )}
    </Button>
  );
}
